export const aprilAbbreviatedLowercase = "hqa";
export default {aprilAbbreviatedLowercase};